import { MatStep, MatStepper } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function getStepSelectedEvent(step: MatStep): Observable<any> {
  return ((step as any)._stepper as MatStepper).selectionChange.pipe(
    filter(({selectedStep}) => selectedStep === step)
  );
}

export function getStepper(step: MatStep): MatStepper {
  return (step as any)._stepper as MatStepper;
}
